import { render, staticRenderFns } from "./pvExam.vue?vue&type=template&id=6a0af550&"
import script from "./pvExam.vue?vue&type=script&lang=js&"
export * from "./pvExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports